import i18n from './../../../../../shared/i18n';
import BaseModel from "../../../../../core/components/input-widget/BaseModel";
import {uuid} from 'vue-uuid';
import helperService from "@/core/services/helper.service";
import cloneDeep from "lodash/cloneDeep";

export default class CommissionForm extends BaseModel {
  uuid = uuid.v4();
  minimum_commission = null;
  insurance_rate = null;
  lot_handling_charge = null;
  rebate_rate = null;
  commissions = [];

  constructor(data = {}) {
    super();
    data = helperService.reverseCalculateTiers(data)
    Object.assign(this, {...data});
  }

  getData() {
    return {
      minimum_commission: parseFloat(this.minimum_commission),
      insurance_rate: parseFloat(this.insurance_rate),
      lot_handling_charge: parseFloat(this.lot_fee),
      rebate_rate: parseFloat(this.rebate_rate)
    };
  }

  rules = {
    minimum_commission: 'required',
    insurance_rate: 'required|max_value:100|min_value:0',
    lot_handling_charge: 'required|numeric',
    rebate_rate: 'required|max_value:100|min_value:0',
  };

  attributeLabels = {
    minimum_commission: i18n.t('Minimum Commission'),
    insurance_rate: i18n.t('L/D Warranty'),
    lot_handling_charge: i18n.t('Entry Fee'),
    rebate_rate: i18n.t('Rebate'),
  };

  toJSON() {
    let data = cloneDeep(super.toJSON());
    data = helperService.calculateTiers(data)
    return data
  }
}
